// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.vatCodes', {
    url: '/vatcodes',
    templateUrl: 'main/configuration/vatCodes/vatCodes.tpl.html',
    data: { pageTitle: 'VAT codes' },
  });
};

angular.module('configuration.vatCodes', []).config(config);
